import {
  baseResponseSchema,
  defaultApi,
  defaultClient,
  ErrorSchema,
} from '@mint-sdk/api-core';
import { z } from 'zod';

export const ColumnTypeEnum = z.enum([
  'currency',
  'date',
  'dateRange',
  'integer',
  'percent',
  'free_form_text',
  'select',
  'decimal',
]);

export type PlacementMdmColumnType = z.infer<typeof ColumnTypeEnum>;

const PlacementMdmColumnOptionSchema = z.object({
  value: z.string(),
  label: z.string(),
  //ag-grid select field doesn't support disabled options and icons
  isDisabled: z.boolean().nullish(),
  iconUrl: z.string().nullish(),
});

export type PlacementMdmColumnOption = z.infer<
  typeof PlacementMdmColumnOptionSchema
>;

const PlacementMdmColumnConfigSchema = z.object({
  id: z.string(),
  label: z.string(),
  type: ColumnTypeEnum,
  decimalPlaces: z.number().nullish(),
  disabledOptions: PlacementMdmColumnOptionSchema.array().nullish(),
  isHidden: z.boolean(),
  isMandatory: z.boolean(),
  isBulkEditable: z.boolean().nullish(),
  isGroupBy: z.boolean().nullish(),
  options: PlacementMdmColumnOptionSchema.array().nullish(),
  filterRelatedFields: z.array(z.string()).nullish(),
  uniquePatternPostfix: z.string().nullish(),
  maxLength: z.number().nullish(),
});

export type PlacementMdmColumnConfig = z.infer<
  typeof PlacementMdmColumnConfigSchema
>;

const PlacementMdmColumnListResponseSchema = z.object({
  data: z
    .object({
      items: z.array(PlacementMdmColumnConfigSchema),
    })
    .nullable(),
  error: ErrorSchema.nullable(),
});

export type PlacementMdmColumnListResponse = z.infer<
  typeof PlacementMdmColumnListResponseSchema
>;

export const getPlacementMdmColumnListQueryOptions = defaultClient.query({
  url: 'planning-service/virtuals/columns/',
  method: 'GET',
  querySchema: z.object({
    mediaItemId: z.string(),
  }),
  snakeCaseQueryParams: true,
  responseSchema: PlacementMdmColumnListResponseSchema,
  processResponse: (data) => data,
});

const UpdatePlacementMdmColumnsRequestSchema = z.object({
  columns: z.array(z.string()),
});

export type UpdatePlacementMdmColumnsRequest = z.infer<
  typeof UpdatePlacementMdmColumnsRequestSchema
>;

export type UpdatePlacementMdmColumnsResponse = z.infer<
  typeof baseResponseSchema
>;

export const updatePlacementMdmColumns = defaultApi.declareEndpoint({
  url: 'planning-service/virtuals/virtual-dsp-campaigns/$mediaItemId/' as const,
  method: 'PATCH',
  requestSchema: UpdatePlacementMdmColumnsRequestSchema,
  responseSchema: baseResponseSchema,
});

export { PlacementMdmColumnListResponseSchema };
